import React, { useEffect, useState } from "react";

import CustomCheckbox from "./CustomCheckbox";
import Label from "./Label";

import styles from "./Field.module.scss";

const CheckboxField = React.forwardRef(
  (
    {
      choices,
      choiceClassName,
      className,
      description,
      errors,
      dataTestId,
      id,
      isInline,
      isRequired,
      onChange,
      label,
      type,
      values,
    },
    ref
  ) => {
    const [checked, setChecked] = useState([]);

    const inlineClass = isInline ? "d-flex align-items-center" : "";
    const isInvalid = errors[id] ? "is-invalid" : "";

    useEffect(() => {
      const _checked = [...(values || [])];
      setChecked(_checked);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (id, value) => {
      let _checked = checked;

      if (value) {
        _checked = Array.from(new Set([..._checked, id]));
      } else {
        _checked = _checked.filter((each) => id !== each);
      }

      setChecked(_checked);
      onChange(_checked);
    };

    const options = choices.map((choiceList, i) => (
      <div className={`${choiceClassName} ${inlineClass}`} key={i}>
        {choiceList.map(({ _id, name }) => (
          <div key={name}>
            <label className={styles.choiceLabel}>
              <CustomCheckbox
                type={type}
                id={name}
                name={id}
                checked={checked.includes(name)}
                value={name}
                ref={ref}
                onChange={handleChange}
              />{" "}
              {name}
            </label>
          </div>
        ))}
      </div>
    ));

    return (
      <div className={`${className} ${styles.formGroup}`} data-testid={dataTestId}>
        <Label id={id} label={label} isRequired={isRequired} />
        <div className="row no-gutters">{options}</div>
        <input type="hidden" className={`${isInvalid}`} />
        {errors[id] && <div className="invalid-feedback">This field is required.</div>}
        <span className={`d-block ${styles.description}`}>{description}</span>
      </div>
    );
  }
);

export default CheckboxField;
